<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo"/>
        <div class="box">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="title is-4">Nuestro Equipo</div>
            </div>
            <div class="column is-8">
              <div class="content">
                <p>Mundo Fotográfico es una empresa familiar con inicio de actividad el 10 de octubre de 1969.</p>
                <p>Se convirtió en el primer negocio de Paraná, Entre Rios en ofrecer productos y/o servicios fotográficos al público en general. Desde sus comienzos, el crecimiento sostenido de MUNDO FOTOGRÁFICO se logra mediante la fijación y concreción de objetivos y metas tales como:</p>
                <ul>
                  <li>Obtener la óptima calidad de producto,</li>
                  <li>Brindar una atención al cliente personalizada y asistida,</li>
                  <li>Lograr la satisfacción total del cliente y</li>
                  <li>Mantener una innovación permanente y continua.</li>
                </ul>
                <p>En un clima de respeto y cordialidad procuramos formar un grupo de trabajo, un equipo de personas que puedan dar respuestas efectivas y rápidas a las inquietudes y preguntas de nuestros clientes. Hoy forman parte de MUNDO FOTOGRÁFICO aproximadamente 20 personas que buscan la satisfacción total del cliente.</p>
              </div>
            </div>
            <div class="column is-4">
              <div class="box">
                <figure class="image">
                  <img src="@/assets/img/nosotros/1.jpg">
                </figure>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="title is-4">Nuestro compromiso con la calidad</div>
            </div>
            <div class="column is-4">
              <div class="box">
                <figure class="image">
                  <img src="@/assets/img/nosotros/2.jpg">
                </figure>
              </div>
            </div>
            <div class="column is-8">
              <div class="content">
                <p>Nuestro valor agregado está presente en la calidad de nuestro servicio y en nuestra gente. Simplemente te brindamos la mejor calidad en la impresión de tus fotografías porque contamos con los mejores equipos de la región y un conjunto de especialistas que le darán ese toque final para que tus fotografías guarden el valor de cada momento. En Mundo Fotográfico utilizamos los mejores equipos KODAK y los mejores insumos para que tus recuerdos queden inmortalizados en nuestro papel KODAK original.</p>
                <p>Nos enfocamos en brindarte solo los mejores productos, tenemos las mejores marcas del mercado en cámaras y accesorios para el profesional o de uso hogareño.</p>
                <p>Pasá por una de nuestras sucursales, elegí uno de nuestros KIOSKOS KODAK y llevate impresa esa fotografía de tu dispositivo movil, cd, dvd, tarjeta de memoria o cualquier otro medio de almacenamiento que tanto querías tener, en el acto y con el mejor papel fotográfico del mercado para que tus recuerdos queden impresos por generaciones.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="title is-4">Nuestro asesoramiento</div>
            </div>
            <div class="column is-8">
              <div class="content">
                <p>
                  <strong>¿Megapixeles? ¿Chip? ¿Micro SD, Tarjeta de memoria? ¿Bluetooth? ¿4:3 o 16:9? ¿Relación de aspecto?</strong>
                </p>
                <p>En Mundo Fotográfico sabemos que tu tiempo vale y que la tecnología es un cambio constante, por eso ya no tenes que preocuparte por conocer sobre formatos, marcas o tecnología, acercate a cualquiera de nuestras sucursales y un miembro de nuestro equipo te asesorará de la mejor manera para que te lleves el producto que estas buscando.</p>
              </div>
            </div>
            <div class="column is-4">
              <div class="box">
                <figure class="image">
                  <img src="@/assets/img/nosotros/3.jpg">
                </figure>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="title is-4">Nuestro respaldo</div>
            </div>
            <div class="column is-4">
              <div class="box">
                <figure class="image">
                  <img src="@/assets/img/nosotros/4.svg">
                </figure>
              </div>
            </div>
            <div class="column is-8">
              <div class="content">
                <p>
                  Pertenecemos a la cadena oficial
                  <strong>KODAK EXPRESS</strong> Servicio de Calidad Controlada, que cuenta con el asesoramiento y soporte exclusivo de
                  <strong>KODAK ARGENTINA S.A.I.C.</strong>
                  s
                </p>
                <p>Es por esto que ofrecemos lo último que existe en el mercado en tecnología, servicio y productos relacionados con la fotografía.</p>
                <p>Somos la elección de muchos profesionales de Entre Ríos y la región. Nuestros clientes conocen la calidad de nuestros productos y nuestra trayectoria, por eso nos siguen eligiendo para equiparlos con la mejor tecnología e imprimir sus trabajos con la mejor calidad.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Promo/>
  </div>
</template>

<script>
import Promo from '@/components/Promo.vue'
import TituloPrincipal from '@/components/TituloPrincipal.vue'

export default {
  name: 'Nosotros',
  data () {
    return {
      titulo: 'Nosotros',
      subtitulo: 'Conocénos mejor'
    }
  },
  components: {
    TituloPrincipal,
    Promo
  }
}
</script>
